'use client'

import { Facebook, Instagram } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SocialIconsProps extends React.HTMLAttributes<HTMLDivElement> {
  showLabels?: boolean
}

export function SocialIcons({ 
  className, 
  showLabels = false, 
  ...props 
}: SocialIconsProps) {
  const socialLinks = [
    { 
      name: 'Facebook', 
      href: 'https://facebook.com', 
      icon: Facebook,
      color: 'hover:text-blue-600'
    },
    { 
      name: 'Instagram', 
      href: 'https://instagram.com', 
      icon: Instagram,
      color: 'hover:text-pink-600'
    },
  ]

  return (
    <div className={cn("flex", className)} {...props}>
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.href}
          aria-label={social.name}
          className={cn(
            "text-muted-foreground hover:text-foreground transition-colors p-2 rounded-md",
            social.color
          )}
          target="_blank"
          rel="noopener noreferrer"
        >
          {showLabels ? (
            <div className="flex items-center gap-2">
              <social.icon className="h-4 w-4" />
              <span className="text-sm">{social.name}</span>
            </div>
          ) : (
            <social.icon className="h-5 w-5" />
          )}
        </a>
      ))}
    </div>
  )
} 